import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { BalootUserAPIs } from "../../../api/APIs";
import { useRequest } from "../../../api/utils/useRequest";
import { DirectDebitStatusType } from "../../../types/DirectDebitTypes";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../../store/actions/ConfigActions";

function DirectDebitContainer() {
  const dispatch = useDispatch();
  const { config } = useSelector((state) => state.config);
  const [enableChecked, setEnableChecked] = useState(false);
  const [serverSubscription, setServerSubscription] = useState(null);
  const [editableSubscription, setEditableSubscription] = useState({
    day: 1,
    amount: 500000.0,
    period: "WEEKLY",
  });
  const { loading: getLoading, apiCall: getSubscription } = useRequest(
    BalootUserAPIs.getSubscription
  );

  const getSubscriptionStatus = () => {
    getSubscription({
      onSuccess: (response) => {
        //update config state to show status on gholak
        dispatch(
          setConfig({
            config: {
              ...config,
              recurringMinAmount: response.config.minAmount,
              profile: {
                ...config.profile,
                hasAutoSaving:
                  response.status === DirectDebitStatusType.ACTIVE
                    ? true
                    : false,
              },
            },
          })
        );
        setEnableChecked(false);
        setServerSubscription(response);
        setEditableSubscription(response);
        if (response.status === DirectDebitStatusType.ACTIVE) {
          setEnableChecked(true);
        }
      },
    });
  };

  useEffect(() => {
    getSubscriptionStatus();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Outlet
        context={{
          getLoading,
          enableChecked,
          setEnableChecked,
          serverSubscription,
          setServerSubscription,
          editableSubscription,
          setEditableSubscription,
          getSubscriptionStatus,
        }}
      />
    </Box>
  );
}

export default DirectDebitContainer;
